import { Collapse, Typography } from "antd";
import React from "react";
import EyeCommonCols from "./EyeCommonCols";

const EyeCare = ({ data }) => {
  const salineData = data?.data?.eye_care_saline_wash;
  const dropsData = data?.data?.eye_care_eye_drops;
  const gelData = data?.data?.eye_care_eye_gel_ointment;
  const tarsorrhaphyData = data?.data?.eye_care_trasorrhaphy;
  const guardData = data?.data?.eye_care_eye_patching_guard;

  const hasSaline = salineData?.length > 0;
  const hasDrops = dropsData?.length > 0;
  const hasGel = gelData?.length > 0;
  const hasTarsorrhaphy = tarsorrhaphyData?.length > 0;
  const hasGuard = guardData?.length > 0;

  if (!hasSaline && !hasDrops && !hasGel && !hasTarsorrhaphy && !hasGuard) {
    return (
      <div style={{ textAlign: "center", padding: "24px 0", color: "#98A2B3" }}>
        <Typography.Text type="secondary">No eye care items</Typography.Text>
      </div>
    );
  }

  const defaultKeys = [];
  if (hasSaline) defaultKeys.push("1");
  if (hasDrops) defaultKeys.push("2");
  if (hasGel) defaultKeys.push("3");
  if (hasTarsorrhaphy) defaultKeys.push("4");
  if (hasGuard) defaultKeys.push("5");

  return (
    <div>
      <Collapse
        expandIconPosition="end"
        defaultActiveKey={defaultKeys}
      >
        {hasSaline && (
          <Collapse.Panel header="Saline Wash" key="1">
            <EyeCommonCols data={salineData} />
          </Collapse.Panel>
        )}
        {hasDrops && (
          <Collapse.Panel header="Eye Drops" key="2">
            <EyeCommonCols data={dropsData} />
          </Collapse.Panel>
        )}
        {hasGel && (
          <Collapse.Panel header="Eye Gel" key="3">
            <EyeCommonCols data={gelData} />
          </Collapse.Panel>
        )}
        {hasTarsorrhaphy && (
          <Collapse.Panel header="Tarsorrhaphy" key="4">
            <EyeCommonCols data={tarsorrhaphyData} />
          </Collapse.Panel>
        )}
        {hasGuard && (
          <Collapse.Panel header="Eye Guard" key="5">
            <EyeCommonCols data={guardData} />
          </Collapse.Panel>
        )}
      </Collapse>
    </div>
  );
};

export default EyeCare;
